@if (disableOnClick) {
    <section class="card project-summary-card">
        <ng-container *ngTemplateOutlet="cardContent" />
    </section>
} @else {
    <a class="card project-summary-card" [routerLink]="[AppPathConsts.ProjectsDetails, projectId]" target="_blank">
        <ng-container *ngTemplateOutlet="cardContent" />
    </a>
}

<ng-template #cardContent>
    <div class="card-main">
        <div class="project-photo">
            <img [src]="imageSource | cdnImage" alt="project" (error)="onImageError($event)" />
        </div>
        <div class="info">
            <span class="type">
                {{ name }}
                <div class="info-id-wrapper">
                    @if (tenantId | smallCompanyLogo; as logoUrl) {
                        <img [src]="logoUrl" class="company-logo" alt="company" />
                    }
                    <div [className]="'info-id ' + (projectStatusName | projectStatusClass)">
                        {{ projectId }}
                    </div>
                </div>
            </span>
            <div class="price">
                <span class="text price-area">
                    <span>{{ priceFrom | moneyRange: priceTo }},&ngsp;</span>
                    <span>{{ areaFrom | squareMetresRange: areaTo }}</span>
                </span>
                <span class="text">
                    {{ address | address: 'full' }}
                </span>
            </div>
        </div>
    </div>
    @if (employeeName) {
        <div class="card-side">
            <span class="employee-name">{{ 'Consultant' | localize }}: {{ employeeName }}</span>
        </div>
    }
</ng-template>
